module.exports = __webpack_public_path__ + "static/media/picture4@2x.f4833ae2.png";